import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {AppNumberPipe} from '@frontend/shared';
import {TranslocoPipe} from '@jsverse/transloco';
import {RfpParticipatingTool, SuitabilityMode} from '../rfp-invitation.types';
import {coverageFor} from '../rfp-suitability.calc';

@Component({
  selector: 'app-rfp-coverage-cell',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppNumberPipe, TranslocoPipe],
  templateUrl: './rfp-coverage-cell.component.html',
})
export class RfpCoverageCellComponent {
  readonly tool = input.required<RfpParticipatingTool>();
  readonly mode = input.required<SuitabilityMode>();

  protected readonly coverage = computed(() => coverageFor(this.tool(), this.mode()));
  protected readonly functionCoverage = computed(
    () => this.tool().suitability?.functionCoverage ?? 0,
  );
  protected readonly countryCoverage = computed(
    () => this.tool().suitability?.countryCoverage ?? 0,
  );
}
